module.exports = __webpack_public_path__ + "static/media/MAAS_JourneyPlanning2.d7d1583a.png";